/* Global value object */
export const GlobalValues = {
    // Global configuration
    appName: "Taskmaster Solution",
    appNameShort: "TS",

    userRoles: [
        {
            id: 1,
            name: "Aggregator administrator"
        },
        {
            id: 2,
            name: "Aggregator Partner Administrator"
        },
        {
            id: 3,
            name: "Aggregator Associates"
        },
        {
            id: 4,
            name: "Customer"
        },
        {
            id: 5,
            name: "CRM"
        }
    ],

    // Role constants
    aggregatorAdministratorRole: {
        id: 1,
        name: "Aggregator administrator"
    },
    aggregatorPartnerAdministratorRole: {
        id: 2,
        name: "Aggregator Partner Administrator"
    },
    organizationEmployeeRole: {
        id: 3,
        name: "Aggregator Associates"
    },
    customerRole: {
        id: 4,
        name: "Customer"
    },
    crmRole: {
        id: 5,
        name: "CRM"
    },

    // Base URLs

    // dashboardBaseUrl: "https://ho.taskmastersolution.com/", //* PROD
    dashboardBaseUrl: "https://task-master-web.pleximus.co.in/", //* STAGING
    // apiBaseUrl: " https://api.taskmastersolution.com/api/", //* PROD
    apiBaseUrl: "https://task-master-api.pleximus.co.in/api/", //* STAGING

    // Client URLs
    // clientBaseUrl: "https://ho.taskmastersolution.com/", //* PROD
    clientBaseUrl: "https://task-master-web.pleximus.co.in/", //* STAGING

    // Authentication URLs
    generateOtpUrl: "user/generate-otp/",
    verifyOtpUrl: "user/verify-otp/",
    refreshTokenUrl: "user/refresh-token/",
    logoutUrl: "user/custom-logout/",

    // Role URLs
    roleListUrl: "role/list/",

    // Aggregator Partner (formerly Organization) URLs
    organizationUrl: "organization/aggregator-partner/manage/",
    organizationCreateUrl: "organization/aggregator-partner/create/",
    organizationListUrl: "organization/list/",
    organizationListFilterUrl: "organization/filter/",
    organizationZoneSyncUrl: "organization/zone/sync/",
    organizationZoneCreateUrl: "organization/zone/create/",
    organizationZoneListUrl: "organization/zone/list/",
    organizationZoneListFilterForPartnerUrl: "organization/zone/list-filter/",
    organizationCategoryCreateUrl: "organization/category/create/",
    organizationCategoryListUrl: "organization/category/list/",
    organizationCategorySyncUrl: "organization/category/sync/",

    // Organization Admin
    organizationAdminListFilterUrl: "user/list-filter-for-super-admin/",
    userCreateUrl: "user/create/",
    userManageUrl: "user/manage/",
    organizationUserListFilterUrl: "user/list-filter-for-vendor-admin/",
    aggregatorAssociateListForPartnerAdminUrl: "user/aggregator-associate/list-for-aggregator-partner-admin/",
    aggregatorAssociateListUrl: "user/aggregator-associate-list/",
    aggregatorAssociateCreateUrl: "user/aggregator-associate/create/",
    aggregatorAssociateManageUrl: "user/aggregator-associate/manage/",
    crmUserCreateUrl: "user/crm/create/",
    crmUserListUrl: "user/crm/list/",
    crmUserListFilterUrl: "user/crm/list-filter/",
    crmUserManageUrl: "user/crm/manage/",

    // Service Category
    serviceCategoryListFilterUrl: "service/category-list-filter/",
    serviceCategoryUrl: "service/category/",
    serviceCategoryListUrl: "service/category-list/",

    // Service Sub Category
    serviceSubCategoryListFilterUrl: "service/sub-category-list-filter/",
    serviceSubCategoryUrl: "service/sub-category/",
    serviceSubCategoryListUrl: "service/sub-category-list/",

    // Service
    serviceListFilterUrl: "service/list-filter/",
    serviceUrl: "service/",
    serviceListUrl: "service/list/",
    serviceReorderUrl: "service/reorder-service/",
    serviceCategoryReorderUrl: "service/reorder-category/",
    serviceSubCategoryReorderUrl: "service/reorder-subcategory/",

    // Service Request List Filter
    serviceRequestVendorAdminListFilterUrl: "service-booking/service-request-list-filter-for-vendor-admin/",
    serviceRequestListFilterForCrmUrl: "service-booking/service-request-list-filter-for-crm/",
    crmServiceRequestListFilterUrl: "service-booking/crm-service-request-list/",
    availableVendorEmployee: "service-booking/vendor-employee-available/",
    serviceBookingAvailableAssociatesUrl: "service-booking/available-associates/",
    serviceRequestAssignEmployee: "service-booking/assign-employee-to-service-request",
    serviceRequestAssignEmployeesToItemUrl: "service-booking/assign-employee-to-service-request-item-new/",
    serviceRequestForwardUrl: "service-booking/forward-service-request-item-new/",
    serviceRequestReject: "service-booking/reject-service-request/",
    servicerRequestDetails: "service-booking/vendor-service-request-detail/",
    crmServiceRequestDetails: "service-booking/service-request-for-crm-manage/",
    crmServiceRequestDetailUrl: "service-booking/crm-service-request-detail/",
    serviceRequestListFilterForNonCrmUrl: "service-booking/service-request-list-filter-for-non-crm/",
    nonCrmServiceRequestDetailUrl: "service-booking/non-crm-service-request-detail/",
    forwardedServiceRequestInternalListFilterUrl: "service-booking/forwarded-service-request-list-filter-for-internal-aggregator/",
    forwardedCrmServiceRequestInternalListUrl: "service-booking/forwarded-crm-service-request-list/",
    exportServiceRequestData: "service-booking/export-service-booking-data/",
    pincodeServiceabilityCheckUrl: "service-booking/pincode-serviceability-check/",
    crmServiceRequestCreateUrl: "service-booking/service-request-for-crm-create",
    availableSlotsUrl: "service-booking/available-slots/",
    aggregatorAssociateListForAdminUrl: "service-booking/aggregator-associate-list-for-admin/",
    // Aggregator Admin Reports
    bookingsRevenueSummaryUrl: "service-booking/bookings-revenue-summary/",
    revenueBifurcationSummaryUrl: "service-booking/revenue-bifurcation-summary/",
    aggregatorAdministratorServiceRequestListUrl: "service-booking/aggregator-administrator-service-request-list/",
    aggregatorAdministratorCrmServiceRequestListUrl: "service-booking/aggregator-administrator-crm-service-request-list/",
    customerAnalyticsRegisteredUtilizedUrl: "customer/analytics/registered-utilized/",
    customerAnalyticsRegisteredUtilizedExportUrl: "customer/analytics/registered-utilized/export/",
    customerAnalyticsDeletedUrl: "customer/analytics/deleted/",
    customerAnalyticsDeletedExportUrl: "customer/analytics/deleted/export/",
    customerAnalyticsRepeatCustomersUrl: "customer/analytics/repeat-customers/",
    customerAnalyticsRepeatCustomersExportUrl: "customer/analytics/repeat-customers/export/",

    // CRM booking dropdowns
    bookingServiceCategoryDropdownUrl: "service-booking/service-category-for-booking-dropdown/",
    bookingServiceSubCategoryDropdownUrl: "service-booking/service-sub-category-for-booking-dropdown/",
    bookingServiceDropdownUrl: "service-booking/service-for-booking-dropdown/",

    // Roster (Aggregator Partner Admin)
    rosterCreateUrl: "roster/create/",
    rosterListUrl: "roster/list/",
    rosterFilterUrl: "roster/filter/",
    rosterManageUrl: "roster/manage/",
    rosterBulkUploadUrl: "roster/bulk-upload/",
    rosterTemplateDownloadUrl: "roster/template-download/",

    // Aggregator Partner Admin Reports
    aggregatorAssociateCustomerFeedbackUrl: "user/aggregator-associate/customer-feedback/",
    aggregatorAssociateTatPerformanceUrl: "user/aggregator-associate/tat-performance/",
    aggregatorAssociateBookingPerformanceUrl: "user/aggregator-associate/booking-performance/",

    // Agreement
    agreementUrl: "agreement/create/",
    agreementManage: "agreement/manage/",

    // State (zone hierarchy)
    stateCreateUrl: "zone/state/create/",
    stateListUrl: "zone/state/list/",
    stateListFilterUrl: "zone/state/list-filter/",
    stateManageUrl: "zone/state/manage/",
    // City (zone hierarchy)
    cityCreateUrl: "zone/city/create/",
    cityListUrl: "zone/city/list/",
    cityListFilterUrl: "zone/city/list-filter/",
    cityManageUrl: "zone/city/manage/",
    // Zone
    zoneListFilterUrl: "zone/list-filter/",
    zoneListUrl: "zone/list/",
    zoneUrl: "zone/manage/",
    zoneCreateUrl: "zone/create/",
    zonePincodeCreateUrl: "zone/pincode/sync/",
    zonePincodeListFilterUrl: "zone/pincode/list-filter/",
    zonePincodeManageUrl: "zone/pincode/manage/"
};

export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

export const ErrorMessages = {
    /* Generic messages */
    required: "This field cannot be blank.",
    maxLength: "This value must be no more than ",
    minLength: "This value must be no less than ",
    invalid: "This value appears to be invalid.",
    invalidDate: "This value is not a valid date.",
    invalidTime: "This value is not a valid time.",
    invalidLocation: "Please select a location from the drop-down list of options.",
    fileRequired: "You must select a file to upload.",
    reportingDateRangeNotSelected: "You must select a date range to run this report.",

    /* Server messages */
    serverErrorPrefix: "Back-End: ",
    severForbiddenError: "You do not have the necessary authorization to make this request.",
    serverNotFoundError: "This data either does not exist or you are not authorized to view it.",
    serverRequestError: "The server is not responding. Please check your internet connection or try again later.",
    serverGenericError: "Something went wrong while attempting to process your request. Please try again later.",

    /* Custom messages */
    CompanyEmployeeNotVerified: "Company Employee is not verified"
};

export const SuccessMessages = {
    // Aggregator Partner
    aggregatorCreated: "The aggregator partner has been created successfully.",
    aggregatorUpdated: "The aggregator partner has been updated successfully.",
    aggregatorDeleted: "The aggregator partner has been deleted successfully.",
    aggregatorZonesSynced: "Aggregator partner zones have been updated successfully.",

    // Aggregator Associates
    aggregatorAssociateCreated: "The aggregator associate has been created successfully.",
    aggregatorAssociateUpdated: "The aggregator associate has been updated successfully.",
    aggregatorAssociateDeleted: "The aggregator associate has been deleted successfully.",

    // Aggregator Partner Administrator
    aggregatorPartnerAdminCreated: "Aggregator partner administrator has been created successfully.",
    aggregatorPartnerAdminUpdated: "Aggregator partner administrator has been updated successfully.",
    aggregatorPartnerAdminDeleted: "Aggregator partner administrator has been deleted successfully.",

    // Roster
    rosterCreated: "Roster entry has been created successfully.",
    rosterUpdated: "Roster entry has been updated successfully.",
    rosterDeleted: "Roster entry has been deleted successfully.",

    // CRM User
    crmUserCreated: "CRM user has been created successfully.",
    crmUserUpdated: "CRM user has been updated successfully.",
    crmUserDeleted: "CRM user has been deleted successfully.",

    // CRM Booking
    crmServiceRequestCreated: "Service booking has been created successfully.",

    // Service Category
    serviceCategoryCreated: "The service category has been created successfully.",
    serviceCategoryUpdated: "The service category has been updated successfully.",
    serviceCategoryDeleted: "The service category has been deleted successfully.",

    // Service Sub-Category
    serviceSubCategoryCreated: "The service sub-category has been created successfully.",
    serviceSubCategoryUpdated: "The service sub-category has been updated successfully.",
    serviceSubCategoryDeleted: "The service sub-category has been deleted successfully.",

    // Service
    serviceCreated: "The service has been created successfully.",
    serviceUpdated: "The service has been updated successfully.",
    serviceDeleted: "The service has been deleted successfully.",
    serviceReordered: "Services have been reordered successfully.",
    serviceCategoryReordered: "Service categories have been reordered successfully.",
    serviceSubCategoryReordered: "Service sub-categories have been reordered successfully.",

    // Organization User
    userCreated: "The user has been created successfully.",
    userUpdated: "The user has been updated successfully.",
    userDeleted: "The user has been deleted successfully.",

    // Service Request Assign
    serviceRequestAssign: "Service Request has been assigned successfully",
    serviceRequestRejected: "Service Request has been rejected successfully",
    serviceRequestForwarded: "Service Request has been forwarded successfully",

    // Agreement
    agreementCreated: "Agreement has been created successfully",
    agreementUpdated: "Agreement has been updated successfully",

    // State
    stateCreated: "The state has been created successfully.",
    stateUpdated: "The state has been updated successfully.",
    stateDeleted: "The state has been deleted successfully.",
    // City
    cityCreated: "The city has been created successfully.",
    cityUpdated: "The city has been updated successfully.",
    cityDeleted: "The city has been deleted successfully.",
    // Zone
    zoneCreated: "The zone has been created successfully.",
    zoneUpdated: "The zone has been updated successfully.",
    zoneDeleted: "The zone has been deleted successfully.",
    zonePincodeAssigned: "Pincode has been assigned to zone successfully.",
    zonePincodeUpdated: "Zone pincode has been updated successfully.",
    zonePincodeDeleted: "Zone pincode has been deleted successfully."
};

/* Util method to convert file into base64 */
export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

/* Util method to find if role is linked */
export const isLinked = (body) => {
    if (
        !body.is_organization_administrator_linked &&
        !body.is_establishment_admin_linked &&
        !body.is_employee_linked &&
        !body.is_security_guard_linked &&
        !body.is_company_employee_admin_linked &&
        !body.is_company_employee_linked
    ) {
        return false;
    }
    return true;
};

export const convertToUTC = (date) => {
    const [hours, minutes, seconds] = date.split(":").map(Number);
    const now = new Date();
    now.setHours(hours);
    now.setMinutes(minutes);
    now.setSeconds(seconds);

    const utcTime = now.toISOString();

    return utcTime;
};

/* Util method to extract time from date object */
export const extractTime = (date) => {
    const hour = date.getHours();
    const minute = date.getMinutes();

    const formattedHour = hour < 10 ? "0" + hour : hour;
    const formattedMinute = minute < 10 ? "0" + minute : minute;

    return formattedHour + ":" + formattedMinute;
};

/* Util method to find an array intersection */
export const findArrayIntersection = (arr1, arr2) => {
    const set = new Set(arr1);
    return arr2.filter((item) => set.has(item));
};

/* Util method to change the body attribute */
export const changeBodyAttribute = (attribute, value) => {
    if (document.body) document.body.setAttribute(attribute, value);
};

/* Utility method to extract location properties from a Google maps object */
export const getLocationFromGoogleMapsObject = (addressComponents) => {
    const location = {
        city: "",
        state: ""
    };

    if (Array.isArray(addressComponents) && addressComponents.length > 0) {
        addressComponents.forEach((item, index) => {
            // Get city
            if (item.types.includes("locality")) {
                location.city = item.long_name;
            }
            // Get state
            if (item.types.includes("administrative_area_level_1")) {
                location.state = item.long_name;
            }
        });
    }
    return location;
};

/* Utility method to convert a date object into the expected format  */
export const formatDate = (date) => {
    let dateObject = new Date(date);
    let month = (dateObject.getMonth() + 1).toString();
    let day = dateObject.getDate().toString();
    let year = dateObject.getFullYear().toString();

    if (month.length < 2) {
        month = "0" + month;
    }
    if (day.length < 2) {
        day = "0" + day;
    }
    return [year, month, day].join("-");
};

/* Utility method to convert a date object into a human readable string  */
export const convertToReadableDate = (date) => {
    return new Date(date).toDateString();
};

/* Utility method to convert a time object into a human readable string  */
export const convertReadableTime = (time) => {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "am" : "pm"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
};

/* Utility method to get all days of week */
export const getDaysOfWeek = () => {
    return [
        {
            label: "Monday",
            value: 1
        },
        {
            label: "Tuesday",
            value: 2
        },
        {
            label: "Wednesday",
            value: 3
        },
        {
            label: "Thursday",
            value: 4
        },
        {
            label: "Friday",
            value: 5
        },
        {
            label: "Saturday",
            value: 6
        },
        {
            label: "Sunday",
            value: 7
        }
    ];
};

/* Utility method to get a particular day of week */
export const getDayOfWeek = (dayIndex) => {
    let day;
    switch (dayIndex) {
        case 1:
            day = {
                label: "Monday",
                value: 1
            };
            break;
        case 2:
            day = {
                label: "Tuesday",
                value: 2
            };
            break;
        case 3:
            day = day = {
                label: "Wednesday",
                value: 3
            };
            break;
        case 4:
            day = day = {
                label: "Thursday",
                value: 4
            };
            break;
        case 5:
            day = day = {
                label: "Friday",
                value: 5
            };
            break;
        case 6:
            day = day = {
                label: "Saturday",
                value: 6
            };
            break;
        case 7:
            day = day = {
                label: "Sunday",
                value: 7
            };
            break;
        default:
            break;
    }
    return day;
};

/* Utility method to get all slots */
export const getDaySlots = () => {
    return [
        {
            label: "00:00",
            value: "00:00:00"
        },
        {
            label: "00:30",
            value: "00:30:00"
        },
        {
            label: "01:00",
            value: "01:00:00"
        },
        {
            label: "01:30",
            value: "01:30:00"
        },
        {
            label: "02:00",
            value: "02:00:00"
        },
        {
            label: "02:30",
            value: "02:30:00"
        },
        {
            label: "03:00",
            value: "03:00:00"
        },
        {
            label: "03:30",
            value: "03:30:00"
        },
        {
            label: "04:00",
            value: "04:00:00"
        },
        {
            label: "04:30",
            value: "04:30:00"
        },
        {
            label: "05:00",
            value: "05:00:00"
        },
        {
            label: "05:30",
            value: "05:30:00"
        },
        {
            label: "06:00",
            value: "06:00:00"
        },
        {
            label: "06:30",
            value: "06:30:00"
        },
        {
            label: "07:00",
            value: "07:00:00"
        },
        {
            label: "07:30",
            value: "07:30:00"
        },
        {
            label: "08:00",
            value: "08:00:00"
        },
        {
            label: "08:30",
            value: "08:30:00"
        },
        {
            label: "09:00",
            value: "09:00:00"
        },
        {
            label: "09:30",
            value: "09:30:00"
        },
        {
            label: "10:00",
            value: "10:00:00"
        },
        {
            label: "10:30",
            value: "10:30:00"
        },
        {
            label: "11:00",
            value: "11:00:00"
        },
        {
            label: "11:30",
            value: "11:30:00"
        },
        {
            label: "12:00",
            value: "12:00:00"
        },
        {
            label: "12:30",
            value: "12:30:00"
        },
        {
            label: "13:00",
            value: "13:00:00"
        },
        {
            label: "13:30",
            value: "13:30:00"
        },
        {
            label: "14:00",
            value: "14:00:00"
        },
        {
            label: "14:30",
            value: "14:30:00"
        },
        {
            label: "15:00",
            value: "15:00:00"
        },
        {
            label: "15:30",
            value: "15:30:00"
        },
        {
            label: "16:00",
            value: "16:00:00"
        },
        {
            label: "16:30",
            value: "16:30:00"
        },
        {
            label: "17:00",
            value: "17:00:00"
        },
        {
            label: "17:30",
            value: "17:30:00"
        },
        {
            label: "18:00",
            value: "18:00:00"
        },
        {
            label: "18:30",
            value: "18:30:00"
        },
        {
            label: "19:00",
            value: "19:00:00"
        },
        {
            label: "19:30",
            value: "19:30:00"
        },
        {
            label: "20:00",
            value: "20:00:00"
        },
        {
            label: "20:30",
            value: "20:30:00"
        },
        {
            label: "21:00",
            value: "21:00:00"
        },
        {
            label: "21:30",
            value: "21:30:00"
        },
        {
            label: "22:00",
            value: "22:00:00"
        },
        {
            label: "22:30",
            value: "22:30:00"
        },
        {
            label: "23:00",
            value: "23:00:00"
        },
        {
            label: "23:30",
            value: "23:30:00"
        }
    ];
};

export const formatReadableTime = (timeStr) => {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    const parts = [];
    // Append hours if present
    if (hours > 0) {
        parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);
    }

    // Append minutes if present
    if (minutes > 0) {
        parts.push(`${minutes} min${minutes > 1 ? "s" : ""}`);
    }

    // Append seconds if present
    if (seconds > 0 || parts.length === 0) {
        // Show seconds if it's 0:00:00
        parts.push(`${seconds} sec${seconds > 1 ? "s" : ""}`);
    }

    return parts.join(", ");
};

export const formatTimeToReadable = (time) => {
    const [hours, minutes] = time.split(":").map(Number);

    const period = hours >= 12 ? "PM" : "AM";

    let displayHours = hours % 12;
    displayHours = displayHours === 0 ? 12 : displayHours;

    return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const sizePerPageList = (data) => {
    return [
        {
            text: "5",
            value: 5
        },
        {
            text: "10",
            value: 10
        },
        {
            text: "25",
            value: 25
        },
        {
            text: "All",
            value: data.length
        }
    ];
};
